import React from 'react';

import RichText from '@elements/RichText';
import SubModuleSelector from '@submodules/SubModuleSelector';
import { getClasses } from '@utils';

import './style.css';

type CardsGroupType = {
  item,
};

const CardsGroup = ({
  item,
}: CardsGroupType): JSX.Element => {

  const mainClasses = getClasses(
    `cards-group--main`,
    item?.modulesWidth && `cards-group--col-${item.modulesWidth}`,
    item?.backgroundColor && `is-bg-${item.backgroundColor}`,
  );

  const headerClasses = getClasses(
    `cards-group__header`,
    item?.headerPosition && `cards-group__header--${item.headerPosition}`,
  );

  return (
    <div className={mainClasses}>
      <div className="cards-group__container">
        <section className="cards-group__inner">
            {
              item.header && (
                <div className={headerClasses}>
                  <RichText bodyRichText={item.header} />
                </div>
              )
            }
          <div className="cards-group__modules">
            <SubModuleSelector submodules={item.modules} />
          </div>
          {
            item.footer && (
              <div className="cards-group__footer">
                <RichText bodyRichText={item.footer} />
              </div>
            )
          }
        </section>
      </div>
    </div>
  );
};

export default CardsGroup;
